import { render, staticRenderFns } from "./memberCommentBoxDistrictEmailList.vue?vue&type=template&id=b1dba2a4&scoped=true"
import script from "./memberCommentBoxDistrictEmailList.vue?vue&type=script&lang=js"
export * from "./memberCommentBoxDistrictEmailList.vue?vue&type=script&lang=js"
import style0 from "./memberCommentBoxDistrictEmailList.vue?vue&type=style&index=0&id=b1dba2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dba2a4",
  null
  
)

export default component.exports